import { useRef } from 'react';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import styles from './EmojiButton.module.css';

const EMOJIS = [
  '😀', '😂', '😊', '😍', '😉', '😢', '😮', '😅', '🤔', '😎',
  '👍', '👎', '👏', '🙏', '🙌', '👋', '💪', '🤝', '✌️', '🤞',
  '🎉', '❤️', '🔥', '⭐', '✅', '❌', '⚠️', '📢', '🔔', '📍',
  '🕒', '📅', '🍕', '🍔', '☕', '🎂', '🎁', '📸', '💬', '🎊',
];

export default function EmojiButton({ textareaRef, value, onInsert, maxLength }) {
  const overlayRef = useRef(null);

  function handlePick(emoji) {
    const el = textareaRef?.current;
    const current = value ?? '';
    const start = el ? (el.selectionStart ?? current.length) : current.length;
    const end = el ? (el.selectionEnd ?? current.length) : current.length;
    const fits = !maxLength || current.length - (end - start) + emoji.length <= maxLength;
    if (fits) onInsert(current.slice(0, start) + emoji + current.slice(end));
    overlayRef.current?.hide();

    if (!el) return;
    const nextPos = start + emoji.length;
    requestAnimationFrame(() => {
      el.focus();
      if (fits) el.setSelectionRange(nextPos, nextPos);
    });
  }

  return (
    <>
      <Button
        type="button"
        icon="pi pi-face-smile"
        text
        rounded
        className={styles.trigger}
        onClick={(e) => overlayRef.current?.toggle(e)}
        aria-label="Insert emoji"
      />
      <OverlayPanel ref={overlayRef} className={styles.panel}>
        <div className={styles.grid}>
          {EMOJIS.map((emoji) => (
            <button
              key={emoji}
              type="button"
              className={styles.emoji}
              onClick={() => handlePick(emoji)}
            >
              {emoji}
            </button>
          ))}
        </div>
      </OverlayPanel>
    </>
  );
}
